import { sbEditable } from '@storyblok/storyblok-editable'
import * as React from 'react'
import { TeaserCardItem } from '../../TeaserCardItem'
import { useI18n } from '../../../lib/context/i18n'
import { TeaserCardCollageItemProps } from './types'
import { TeaserCardCollageItemWrapper } from './styled'

export const TeaserCardCollageItem = ({ blok, index, showStep }: TeaserCardCollageItemProps) => {
  const indexText = (index < 10 ? `0${index + 1}` : index + 1).toString()
  const { getTranslatedUrlFromLink } = useI18n()

  return (
    <TeaserCardCollageItemWrapper {...sbEditable(blok)}>
      <TeaserCardItem
        step={showStep ? `${indexText}.` : undefined}
        blok={blok}
        justify="left"
        href={blok.Link?.length > 0 ? getTranslatedUrlFromLink(blok.Link[0].link) : undefined}
      />
    </TeaserCardCollageItemWrapper>
  )
}
